import React, { useState } from "react";
import {
  IonModal,
  IonButton,
  IonIcon,
  IonText,
} from "@ionic/react";
import {
  addCircleOutline,
  peopleCircleOutline,
  megaphoneOutline,
} from "ionicons/icons";

interface SchedulerOnboardingProps {
  isOpen: boolean;
  onFinish: () => void;
}

const slides = [
  {
    icon: addCircleOutline,
    title: "Create a Job",
    body: "Tap the \"+\" button at the bottom right to create a new job. Fill in the details, pick a date, and send it to your associates.",
  },
  {
    icon: peopleCircleOutline,
    title: "Build Your Crews",
    body: "Go to Associates and tap the Crews segment. Create a crew of your associates so you can send jobs and announcements to the whole group at once.",
  },
  {
    icon: megaphoneOutline,
    title: "Send Announcements",
    body: "From the Announcements section, post updates that go out to your associates or specific crews. Keep everyone in the loop.",
  },
];

const SchedulerOnboarding: React.FC<SchedulerOnboardingProps> = ({ isOpen, onFinish }) => {
  const [step, setStep] = useState(0);

  const handleNext = () => {
    if (step < slides.length - 1) {
      setStep(step + 1);
    } else {
      setStep(0);
      onFinish();
    }
  };

  const handleSkip = () => {
    setStep(0);
    onFinish();
  };

  const current = slides[step];

  return (
    <IonModal isOpen={isOpen} backdropDismiss={false}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          padding: "40px 28px",
          textAlign: "center",
        }}
      >
        <IonIcon
          icon={current.icon}
          style={{ fontSize: "72px", color: "var(--ion-color-secondwarning)", marginBottom: 24 }}
        />
        <IonText>
          <h2 style={{ fontWeight: 700, fontSize: "22px", margin: "0 0 12px" }}>
            {current.title}
          </h2>
        </IonText>
        <IonText color="medium">
          <p style={{ fontSize: "16px", lineHeight: 1.5, margin: "0 0 32px" }}>
            {current.body}
          </p>
        </IonText>

        {/* Dots */}
        <div style={{ display: "flex", gap: 8, marginBottom: 32 }}>
          {slides.map((_, i) => (
            <div
              key={i}
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background:
                  i === step
                    ? "var(--ion-color-secondwarning)"
                    : "var(--ion-color-medium)",
                opacity: i === step ? 1 : 0.3,
              }}
            />
          ))}
        </div>

        <IonButton expand="block" color="secondwarning" onClick={handleNext} style={{ width: "100%", maxWidth: 300 }}>
          {step < slides.length - 1 ? "Next" : "Let's Go"}
        </IonButton>

        {step < slides.length - 1 && (
          <IonButton fill="clear" color="medium" onClick={handleSkip} style={{ marginTop: 8 }}>
            Skip
          </IonButton>
        )}
      </div>
    </IonModal>
  );
};

export default SchedulerOnboarding;
